import React from 'react';
import { Button } from 'antd';

interface Props {
  userName: string;
  onStart: () => void;
}

const StepWelcome: React.FC<Props> = ({ userName, onStart }) => (
  <div style={{
    padding: '48px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 24,
  }}>
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="wg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#5B00EF" />
          <stop offset="1" stopColor="#8346F3" />
        </linearGradient>
      </defs>
      <circle cx="48" cy="48" r="44" fill="#F7F2FE" />
      <circle cx="48" cy="48" r="30" fill="url(#wg)" />
      <path d="M50 32 36 52h12l-2 14 14-20H48l2-14Z"
        fill="#fff" stroke="#fff" strokeWidth="1.2" strokeLinejoin="round" />
      <circle cx="78" cy="22" r="4" fill="#FF372D" />
      <circle cx="18" cy="72" r="3" fill="#FC850D" />
      <circle cx="82" cy="70" r="2.5" fill="#029B2D" />
    </svg>

    <div>
      <h1 style={{ fontSize: 28, fontWeight: 700, color: '#202020', marginBottom: 8 }}>
        Boas-vindas,{' '}
        <span style={{ color: '#5b00ef' }}>{userName}</span>!
      </h1>
      <p style={{ fontSize: 15, color: '#4c5462', lineHeight: 1.55, maxWidth: 480, margin: '0 auto' }}>
        É um prazer ter você na Tupi. Antes de cadastrar suas estações, precisamos de
        algumas informações para criar sua empresa na plataforma. Leva só alguns minutos.
      </p>
    </div>

    <ul style={{
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 12,
      textAlign: 'left',
      width: '100%',
      maxWidth: 480,
    }}>
      {[
        { num: 1, title: 'Dados da empresa', desc: 'Nome, CNPJ, tipo de cliente e documentos.' },
        { num: 2, title: 'Dados financeiros', desc: 'Apenas para operadores de rede (CPO).' },
        { num: 3, title: 'Análise e ativação', desc: 'Aprovamos seu cadastro em até 3 dias úteis.' },
      ].map(({ num, title, desc }) => (
        <li key={num} style={{
          display: 'grid',
          gridTemplateColumns: '32px 1fr',
          gap: 14,
          padding: 16,
          border: '1px solid #e9ecf0',
          borderRadius: 12,
          background: '#fcfcfd',
        }}>
          <span style={{
            width: 32, height: 32, borderRadius: '50%',
            background: '#f7f2fe', color: '#3d009e',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 600, fontSize: 13,
          }}>
            {num}
          </span>
          <div>
            <strong style={{ fontSize: 14, color: '#202020', display: 'block' }}>{title}</strong>
            <span style={{ fontSize: 13, color: '#4c5462' }}>{desc}</span>
          </div>
        </li>
      ))}
    </ul>

    <Button
      type="primary"
      size="large"
      onClick={onStart}
      style={{ background: '#5b00ef', borderColor: '#5b00ef', minWidth: 240 }}
    >
      Começar cadastro da empresa
    </Button>
  </div>
);

export default StepWelcome;
